import { SET_OPENING_BALANCE_DATA, SET_OPENING_BALANCE_ID } from "constants/openingBalanceConstants";

export const setOpeningBalanceData = (openingBalance) => {
  return {
    type: SET_OPENING_BALANCE_DATA,
    openingBalance,
  };
};
export const setOpeningBalanceId = (id) => {
  return {
    type: SET_OPENING_BALANCE_ID,
    id,
  };
};
